import { createSelector } from 'reselect';
import { profileReducerKey } from './ProfileConstants';

export function profile(state) {
  return state.get(profileReducerKey);
}

export function isLoading(state) {
  return profile(state).get('isLoading');
}

export function inputData(state) {
  return profile(state).get('inputData');
}

export const valueByFieldName = (fieldName) =>
  // eslint-disable-next-line no-shadow
  createSelector([inputData], (inputData) => {
    const value = inputData[fieldName];
    return value ? value.trim() : value;
  });

export function allSalutations(state) {
  return profile(state).get('allSalutations');
}
